export default [
  {
    name: 'visa',
    fullName: 'visa',
    bins: /^4[0-9]{15}$/,
    codeLength: 3,
  },

  {
    name: 'master',
    fullName: 'mastercard',
    bins: /^((5(([1-2]|[4-5])[0-9]{8}|0((1|6)([0-9]{7}))|3(0(4((0|[2-9])[0-9]{5})|([0-3]|[5-9])[0-9]{6})|[1-9][0-9]{7})))|((508116)\\d{4,10})|((502121)\\d{4,10})|((589916)\\d{4,10})|(2[0-9]{15})|(67[0-9]{14})|(506387)\\d{4,10})/,
    codeLength: 3,
  },

  {
    name: 'elo',
    fullName: 'elo',
    bins: /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/,
    codeLength: 3,
  },

  {
    name: 'aura',
    fullName: 'aura',
    bins: /^((?!504175))^((?!5067))(^50[0-9])/,
    codeLength: 3,
  },

  {
    name: 'jcb',
    fullName: 'jcb',
    bins: /^(?:2131|1800|35\d{3})\d{11}/,
    codeLength: 3,
  },

  {
    name: 'amex',
    fullName: 'american-express',
    bins: /^3[47][0-9]{13}$/,
    codeLength: 4,
  },

  {
    name: 'hiper',
    fullName: 'hiper',
    bins: /^(38[0-9]{17}|60[0-9]{14})$/,
    codeLength: 3,
  },

  {
    name: 'banescard',
    fullName: 'banescard',
    bins: /^(603182)[0-9]{10,12}/,
    codeLength: 3,
  },

  {
    name: 'hipercard',
    fullName: 'hipercard',
    bins: /^606282|^3841(?:[0|4|6]{1})0/,
    codeLength: 3,
  },

  {
    name: 'discover',
    fullName: 'discover',
    bins: /^(6011\d{12}|(62212[6-9]|6221[3-9]\d|622[2-8]\d\d|6229[01]\d|62292[0-5])\d{10}|64[4-9]\d{13}|65\d{14})$/,
    codeLength: 3,
  },

  {
    name: 'cabal',
    fullName: 'cabal',
    bins: /^(604\d{13}|589657\d{10}|627170\d{10})$/,
    codeLength: 3,
  },

  {
    name: 'diners',
    fullName: 'diners-club',
    bins: /^((300|301|302|303|304|305)\d{11}|36\d{12}|38\d{12})$/,
    codeLength: 3,
  },
];